export default __webpack_public_path__ + "static/media/BA12.fa733e47.jpg";